import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LpmConfig } from 'app/models/lpm.config';
import { Util } from 'app/models/util';

/**
 * Resolves a piece of UI copy against the host's lpmConfig, so any host can override
 * app terminology (e.g. PracticePanther using "Delete" instead of "Trash") without a
 * code change here. Falls back to the given default when the host hasn't set that key.
 *
 * Usage: {{ 'Trash' | lpmLabel:'deleteLabelText' }}
 */
@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'lpmLabel',
  standalone: true
})
export class LpmLabelPipe implements PipeTransform {

  constructor(private util: Util) {}

  transform(defaultText: string, configKey: keyof LpmConfig): string {
    const value = this.util.getWebComponentInputParams()?.lpmConfig?.[configKey];
    return (typeof value === 'string' && value) ? value : defaultText;
  }
}
